import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-45db3f1b")

_pushScopeId("data-v-45db3f1b")
const _hoisted_1 = { class: "payment-wrap" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.payments, (item) => {
      return (_openBlock(), _createBlock("div", {
        class: "payment-item",
        key: item.type
      }, [
        _createVNode("input", {
          type: "radio",
          id: item.name,
          name: "payment",
          value: item.type,
          disabled: _ctx.interdict.includes(item.type),
          checked: _ctx.current?.type === item.type,
          onChange: ($event: any) => (_ctx.handleChange(item.type))
        }, null, 40, ["id", "value", "disabled", "checked", "onChange"]),
        _createVNode("label", {
          class: "payment-item-label",
          for: item.name
        }, [
          _createVNode("img", {
            src: item.icon,
            alt: "",
            class: "payment-item-icon"
          }, null, 8, ["src"]),
          _createVNode("span", null, _toDisplayString(item.name), 1)
        ], 8, ["for"])
      ]))
    }), 128))
  ]))
})